export default function ProblemsSection() {
  const problems = [
    {
      title: "平日は忙しくて、\n親の通院に付き添えない",
      desc: "送迎、院内・診察の付き添い、診察内容のご報告まで対応いたします。",
      icon: "ri-hospital-line",
      label: "通院のサポート",
      image: "https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/336417a8ea180d980179eeb97cf5a630.png"
    },
    {
      title: "一人暮らしの親が\n引きこもりがちで心配",
      desc: "趣味の継続をサポートすることで、心身の健康を維持・向上します。",
      icon: "ri-walk-line",
      label: "人生の楽しみをサポート",
      image: "https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/15a7464e7c92301f41a6538c8dd63abb.png"
    },
    {
      title: "家の片付けや\n書類整理を手伝ってほしい",
      desc: "生活・書類サポートで、片付けや書類整理をサポートし、暮らしやすい空間作りをお手伝いします。",
      icon: "ri-file-list-3-line",
      label: "日常のサポート",
      image: "https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/4025486216ba6896e5e449ec729e5c08.png"
    }
  ];

  return (
    <section id="problems" className="py-28 bg-gradient-to-b from-[#FFFBF0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-24">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-6 leading-tight">
            そのお悩み、ソトマゴが力になります
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-brand-yellow via-brand-yellow-dark to-brand-yellow mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          {problems.map((problem, index) => (
            <div 
              key={index} 
              className="bg-white border-2 border-gray-100 rounded-3xl p-10 shadow-md hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 h-full flex flex-col group relative overflow-hidden"
            >
              {/* 背景装飾 */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-brand-yellow/10 to-transparent rounded-full -translate-y-20 translate-x-20 group-hover:scale-150 transition-transform duration-700"></div>
              
              {/* アイコンとラベル - 左上配置 */}
              <div className="flex items-center gap-4 mb-8 relative z-10">
                <div className="w-16 h-16 bg-gradient-to-br from-brand-yellow via-brand-yellow-dark to-[#E6A600] rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 relative flex-shrink-0">
                  <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent rounded-2xl"></div>
                  <i className={`${problem.icon} text-2xl text-white relative z-10`}></i>
                </div>
                <h4 className="text-lg font-bold text-brand-dark whitespace-nowrap">
                  {problem.label}
                </h4>
              </div>

              {/* 画像 */}
              <div className="mb-8 flex-shrink-0 relative z-10 overflow-hidden rounded-2xl">
                <img 
                  src={problem.image} 
                  alt={problem.title}
                  className="w-full h-56 object-cover object-top shadow-md group-hover:shadow-lg group-hover:scale-105 transition-all duration-500"
                />
              </div>

              {/* テキストコンテンツ - 左寄せ */}
              <div className="flex-grow flex flex-col justify-start text-left relative z-10">
                <h3 className="text-xl md:text-2xl font-bold text-brand-dark mb-6 leading-relaxed whitespace-pre-line">
                  {problem.title}
                </h3>
                <p className="text-gray-600 text-base leading-loose whitespace-pre-line">
                  {problem.desc}
                </p>
              </div>

              {/* ボトム装飾ライン */}
              <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-transparent via-brand-yellow to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}